import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '../index';
import { memoryRemindersKeys } from './memoryReminders.keys';
import { getReminders, createReminder, updateReminder, pauseReminder, resumeReminder, cancelReminder } from './memoryReminders.api';
export const useRemindersQuery = () => {
    return useQuery({
        queryKey: memoryRemindersKeys.all(),
        queryFn: getReminders,
        refetchInterval: 5000,
        staleTime: 0
    });
};
export const useCreateReminderMutation = () => {
    return useMutation({
        mutationFn: createReminder,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: memoryRemindersKeys.all() }).then();
        }
    });
};
export const useUpdateReminderMutation = () => {
    return useMutation({
        mutationFn: updateReminder,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: memoryRemindersKeys.all() }).then();
        }
    });
};
export const usePauseReminderMutation = () => {
    return useMutation({
        mutationFn: pauseReminder,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: memoryRemindersKeys.all() }).then();
        }
    });
};
export const useResumeReminderMutation = () => {
    return useMutation({
        mutationFn: resumeReminder,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: memoryRemindersKeys.all() }).then();
        }
    });
};
export const useCancelReminderMutation = () => {
    return useMutation({
        mutationFn: cancelReminder,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: memoryRemindersKeys.all() }).then();
        }
    });
};
//# sourceMappingURL=memoryReminders.query.js.map